













































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import Util from "../../../lib/util";
import AppConsts from "@/lib/appconst";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreatePurchaseOrderLineDto from "../../../store/entities/create-purchase-order-line";
import CreatePurchaseOrderDto from "../../../store/entities/create-purchase-order";
import SalesOrderForSelect from "@/store/entities/sales-orders/sales-order-for-select";
import ProductForSelect from "@/store/entities/products/product-for-select";
import SupplierForSelect from "@/store/entities/suppliers/supplier-for-select";
import _ from "lodash";
import Barcode from "../../components/bar-code.vue";
import moment from "moment";
Vue.use(require("vue-moment"));
class PagePurchaseOrderLineRequest extends PageRequest {
  sku: string;
}
@Component({
  components: { "bar-code": Barcode, "vue-editor":  VueEditor },
})
export default class CreateUpdatePurchaseOrder extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  code: string = "";
  id: number = 0;
  clientCode: string = "";
  pagerequest: PagePurchaseOrderLineRequest = new PagePurchaseOrderLineRequest();
  purchaseOrder: CreatePurchaseOrderDto = new CreatePurchaseOrderDto();
  purchaseOrderLines: Array<CreatePurchaseOrderLineDto> = new Array<
    CreatePurchaseOrderLineDto
  >();
  purchaseOrderLinesPerPage: Array<CreatePurchaseOrderLineDto> = new Array<
    CreatePurchaseOrderLineDto
  >();
  filterTotalCount: number = 0;
  sku: string = "";
  qty: number = 1;
  spinShow: boolean = false;
  returnSalsOrders: Array<SalesOrderForSelect> = new Array<
    SalesOrderForSelect
  >();
  products: Array<ProductForSelect> = new Array<ProductForSelect>();
  suppliers: Array<SupplierForSelect> = new Array<SupplierForSelect>();
  assetTypes: Array<any> = [];
  conditionTypes: Array<any> = [];
  objectLoading: boolean = false;
  poTypeName: string = "";
  clients = [];
  warehouses = [];
  soLines = [];
  productTypes = [];
  buyFroms = [];
  month: number = null;
  year: number = null;
  supplierNation: string = "";
  isTp: boolean = false;
  months = [];
  years = [];
  types = [];
  poTypePrefix = AppConsts.tableRef.tablePo.prefix.type;
  productTypeName = "";
  shipSalesOrders: Array<SalesOrderForSelect> = new Array<
    SalesOrderForSelect
  >();
  get isAccessories() {
    return this.purchaseOrder.productType === AppConsts.poProductType.LK;
  }
  getCurrentEndOfMonthDate() {
    return moment(new Date())
      .endOf("month")
      .toDate();
  }
  searchProduct_OnPress = _.debounce(
    this.searchProductForSelect,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  searchReturnSO_OnPress = _.debounce(
    this.searchSoForReturn,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  searchShipSO_OnPress = _.debounce(
    this.searchSoForShip,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  get minYear() {
    let currentDate = new Date();
    return currentDate.getFullYear() - 5;
  }
  get maxYear() {
    let currentDate = new Date();
    return currentDate.getFullYear() + 5;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  isUpdate() {
    return this.id > 0 && !Util.isEmpty(this.code);
  }
  async getTypes() {
    this.$store
      .dispatch({
        type: "purchaseOrder/getListClientCentralTypeForSelect",
      })
      .then((result) => {
        this.types = result;
      });
  }
  changeProductType() {
    this.isTp = this.purchaseOrder.productType === AppConsts.poProductType.TP;
    this.productTypeName =
      _.isNil(this.purchaseOrder.productType) ||
      _.isEmpty(this.purchaseOrder.productType)
        ? ""
        : Util.L("PoProductType" + this.purchaseOrder.productType);
  }
  
  get client() {
    return this.$store.state.session.client;
  }
  getMonthList() {
    let months = [];
    for (let i = 1; i <= 12; i++) {
      if (i < 10) {
        months.push({
          id: i,
          displayName: "0" + i.toString(),
        });
      } else {
        months.push({
          id: i,
          displayName: i.toString(),
        });
      }
    }
    this.months = months;
  }
  getYearList() {
    let years = [];
    for (let i = this.minYear; i <= this.maxYear; i++) {
      years.push({
        id: i,
        displayName: i,
      });
    }
    this.years = years;
  }
  changeManufactureYearLine(row, index) {
    let yearValue = row.year;
    var line = this.purchaseOrderLines.find(
      (i) => i.productId === row.productId
    );
    this.purchaseOrderLinesPerPage[index].year = yearValue;
    line.year = yearValue;
    row.year = yearValue;
  }
  changeManufactureMonthLine(row, index) {
    let monthValue = row.month;
    var line = this.purchaseOrderLines.find(
      (i) => i.productId === row.productId
    );
    this.purchaseOrderLinesPerPage[index].month = monthValue;
    line.month = monthValue;
    row.month = monthValue;
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        this.$set(
          this.purchaseOrder,
          "clientCode",
          re.length > 0 ? re[0].code : ""
        );
        this.clients = re;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.warehouses = re;
      });
  }
  async getConditionTypes() {
    await this.$store
      .dispatch({
        type: "masterData/getFeatureConditionTypesForSelect",
        data: {
          featureCode: AppConsts.featureConditionType.PO_Create,
          hasAllItem: false,
        },
      })
      .then((result) => {
        this.conditionTypes = result;
        this.purchaseOrder.conditionTypeCode =
          this.conditionTypes.length > 0 ? this.conditionTypes[0].id : "";
      });
  }
  async getClientAssetTypes() {
    await this.$store
      .dispatch({
        type: "client/getClientAssetTypeServices",
        data: this.purchaseOrder.clientCode,
      })
      .then((result) => {
        var re = this.$store.state.client.clientAssetTypes;
        this.$set(
          this.purchaseOrder,
          "assetTypeCode",
          re.length === 0 ? "" : re[0].id
        );
        this.assetTypes = re;
      });
  }
  async getProductTypes() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getListTypeForSelect",
        data: {
          tableName: AppConsts.tableRef.tablePo.name,
          columnName: AppConsts.tableRef.tablePo.column.productType,
          prefix: AppConsts.tableRef.tablePo.prefix.productType,
          hasAllItem: false,
        },
      })
      .then((re) => {
        this.productTypes = re;
        this.purchaseOrder.productType =
          Util.isNull(this.productTypes) || this.productTypes.length === 0
            ? ""
            : this.productTypes[0].code;
        this.changeProductType();
      });
  }

  async getBuyFroms() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getListTypeForSelect",
        data: {
          tableName: AppConsts.tableRef.tablePo.name,
          columnName: AppConsts.tableRef.tablePo.column.buyFrom,
          prefix: AppConsts.tableRef.tablePo.prefix.buyFrom,
          hasAllItem: false,
        },
      })
      .then((re) => {
        this.$set(
          this.purchaseOrder,
          "buyFrom",
          re.length === 0 ? "" : re[0].code
        );
        this.buyFroms = re;
      });
  }

  getPoTypeName() {
    this.poTypeName =
      Util.L("PurchaseOrder") +
      " - " +
      Util.L(AppConsts.tableRef.tablePo.prefix.type + this.purchaseOrder.type);
  }

  async searchProductForSelect(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    this.products = await this.$store.dispatch({
      type: "product/searchProductForSelect",
      data: {
        clientCode: this.purchaseOrder.clientCode,
        keyWord: keyword,
        poProductType: this.purchaseOrder.productType,
        productType: AppConsts.productTypes.goods,
      },
    });
    this.objectLoading = false;
  }
  async searchSupplierForSelect() {
    this.suppliers = await this.$store.dispatch({
      type: "supplier/searchSupplierForSelect",
      data: {
        clientCode: this.purchaseOrder.clientCode,
        keyWord: "",
      },
    });
  }
  changeSupplier() {
    let supplier = _.find(this.suppliers, [
      "id",
      this.purchaseOrder.supplierCode,
    ]);
    if (!Util.isNull(supplier)) {
      this.supplierNation = supplier.nation;
    }
  }
  changeProduct() {
    if (Util.isNull(this.sku) || Util.isEmpty(this.sku)) {
      return;
    }
    var product = _.find(this.products, ["sku", this.sku]);
    if (Util.isNull(product)) {
      Util.showErrorMsg(this, "Error.ProductNotExist");
      return;
    }
  }
  async changeClientCode() {
    if (
      _.isNil(this.purchaseOrder.clientCode) ||
      _.isEmpty(this.purchaseOrder.clientCode)
    )
      return;
    if (this.purchaseOrderLines.length > 0) {
      this.$Modal.confirm({
        title: this.L("Tips"),
        content: this.L(`Confirm.ResetPurchaseOrderDetails`),
        okText: this.L("Yes"),
        cancelText: this.L("No"),
        onOk: async () => {
          await this.resetChangeClientCode();
          await this.loadClientData();
        },
      });
    } else {
      await this.resetChangeClientCode();
      await this.loadClientData();
    }
  }
  async loadClientData() {
    if (!this.isReturnSO()) {
      await this.getClientAssetTypes();
    } else {
      await this.renderSoData();
    }
    await this.searchSupplierForSelect();
  }
  // Return SO =====================
  isReturnSO() {
    return (
      !Util.isNull(this.purchaseOrder) &&
      !Util.isEmpty(this.purchaseOrder.type) &&
      this.purchaseOrder.type == AppConsts.poTypes.returnSalesOrderAfterPack
    );
  }
  async searchSoForReturn(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    this.resetReturnSoInfo();
    this.returnSalsOrders = await this.$store.dispatch({
      type: "saleOrder/searchSoForReturn",
      data: {
        clientCode: this.purchaseOrder.clientCode,
        keyWord: keyword,
      },
    });
    this.objectLoading = false;
  }
  async changeReturnSo() {
    if (this.purchaseOrderLines.length > 0) {
      this.$Modal.confirm({
        title: this.L("Tips"),
        content: this.L(`Confirm.ResetPurchaseOrderDetails`),
        okText: this.L("Yes"),
        cancelText: this.L("No"),
        onOk: async () => {
          await this.renderSoData();
        },
      });
    } else {
      await this.resetList();
      await this.renderSoData();
    }
  }
  async onchangeAssetConditionType() {
    if (this.isReturnSO() || this.isShipSO()) {
      await this.getSoLines();
    }
  }
  async getReturnSoInfo(so: any) {
    this.purchaseOrder.returnSoCode = so.code;
    this.purchaseOrder.contactName = so.customerName;
    this.purchaseOrder.contactPhone = so.customerPhone;
    this.assetTypes = so.assetTypes;
    this.purchaseOrder.assetTypeCode =
      this.assetTypes.length <= 0 ? "" : this.assetTypes[0].id;
    this.conditionTypes = so.conditionTypes;
    this.purchaseOrder.conditionTypeCode =
      this.conditionTypes.length <= 0 ? "" : this.conditionTypes[0].id;
    this.purchaseOrder.containerNumber = so.code;
    this.purchaseOrder.invoiceNumber = so.code;
    this.purchaseOrder.invoiceDate = this.getCurrentEndOfMonthDate();
    this.purchaseOrder.productType = so.productType;
    this.soLines = so.soLines;
    this.changeProductType();
    await this.getSoLines();
  }
  async getSoLines() {
    var assetTypeCode = this.purchaseOrder.assetTypeCode;
    var conditionTypeCode = this.purchaseOrder.conditionTypeCode;
    var lines = _.filter(this.soLines, function(o) {
      return (
        o.assetTypeCode === assetTypeCode &&
        o.conditionTypeCode === conditionTypeCode
      );
    });
    if (this.purchaseOrder.productType === AppConsts.poProductType.TP) {
      var month = new Date().getMonth();
      var year = new Date().getFullYear();
      lines.forEach(function(item) {
        item.month = month + 1;
        item.year = year;
      });
    }
    this.purchaseOrderLines = lines;
    await this.getpage();
  }
  resetReturnSoInfo() {
    this.assetTypes = [];
    this.conditionTypes = [];
    this.purchaseOrder.assetTypeCode = "";
    this.purchaseOrder.conditionTypeCode = "";
    this.purchaseOrder.returnSoCode = "";
    this.purchaseOrder.contactName = "";
    this.purchaseOrder.contactPhone = "";
    this.purchaseOrder.containerNumber = "";
    this.purchaseOrder.invoiceNumber = "";
    this.purchaseOrder.invoiceDate = this.getCurrentEndOfMonthDate();
    this.purchaseOrder.productType = "";
    this.changeProductType();
    this.resetList();
  }
  async renderSoData() {
    if (this.purchaseOrder.returnSoId > 0) {
      await this.$store
        .dispatch({
          type: "saleOrder/getSoForReturn",
          data: { id: this.purchaseOrder.returnSoId },
        })
        .then(async (result) => {
          this.resetReturnSoInfo();
          if (Util.isNull(result)) {
            Util.showErrorMsg(this, "Error.SoNotExist");
            return;
          }
          await this.getReturnSoInfo(result);
        });
    } else {
      this.resetReturnSoInfo();
    }
  }
  // Ship SO =====================
  isShipSO() {
    return (
      !Util.isNull(this.purchaseOrder) &&
      !Util.isEmpty(this.purchaseOrder.type) &&
      this.purchaseOrder.type == AppConsts.poTypes.ship
    );
  }
  async searchSoForShip(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    this.resetShipSoInfo();
    this.shipSalesOrders = await this.$store.dispatch({
      type: "saleOrder/searchSoForShip",
      data: {
        keyWord: keyword,
      },
    });
    this.objectLoading = false;
  }
  async changeShipSo() {
    if (this.purchaseOrderLines.length > 0) {
      this.$Modal.confirm({
        title: this.L("Tips"),
        content: this.L(`Confirm.ResetPurchaseOrderDetails`),
        okText: this.L("Yes"),
        cancelText: this.L("No"),
        onOk: async () => {
          await this.renderShipSoData();
        },
      });
    } else {
      await this.resetList();
      await this.renderShipSoData();
    }
  }
  async getShipSoInfo(so: any) {
    this.purchaseOrder.externalSoCode = so.code;
    this.purchaseOrder.contactName = so.customerName;
    this.purchaseOrder.contactPhone = so.customerPhone;
    this.assetTypes = so.assetTypes;

    this.purchaseOrder.assetTypeCode =
      this.assetTypes.length <= 0 ? "" : this.assetTypes[0].id;
    this.conditionTypes = so.conditionTypes;
    this.purchaseOrder.conditionTypeCode =
      this.conditionTypes.length <= 0 ? "" : this.conditionTypes[0].id;
    this.purchaseOrder.containerNumber = so.code;
    this.purchaseOrder.invoiceNumber = so.code;
    this.purchaseOrder.invoiceDate = this.getCurrentEndOfMonthDate();
    this.purchaseOrder.productType = so.productType;
    this.soLines = so.soLines;
    this.changeProductType();
    await this.getSoLines();
  }

  resetShipSoInfo() {
    this.assetTypes = [];
    this.conditionTypes = [];
    this.purchaseOrder.assetTypeCode = "";
    this.purchaseOrder.conditionTypeCode = "";
    this.purchaseOrder.externalSoCode = "";
    this.purchaseOrder.contactName = "";
    this.purchaseOrder.contactPhone = "";
    this.purchaseOrder.containerNumber = "";
    this.purchaseOrder.invoiceNumber = "";
    this.purchaseOrder.invoiceDate = this.getCurrentEndOfMonthDate();
    this.purchaseOrder.productType = "";
    this.changeProductType();
    this.resetList();
  }
  async renderShipSoData() {
    if (this.purchaseOrder.externalSoId > 0) {
      await this.$store
        .dispatch({
          type: "saleOrder/getSoForShip",
          data: { id: this.purchaseOrder.externalSoId },
        })
        .then(async (result) => {
          this.resetShipSoInfo();
          if (Util.isNull(result)) {
            Util.showErrorMsg(this, "Error.SoNotExist");
            return;
          }
          await this.getShipSoInfo(result);
        });
    } else {
      this.resetShipSoInfo();
    }
  }
  //=============================
  async checkProduct() {
    if (Util.isNull(this.sku) || Util.isEmpty(this.sku)) {
      Util.showErrorMsg(this, "Error.SkuRequired");
      return;
    }
    if (this.isTp) {
      var argusMonth = [Util.L("ManufactureMonth")];
      if (Util.isNull(this.month) || Util.isEmpty(this.month.toString())) {
        Util.showErrorMsg(this, Util.L("Error.RequiredField0", ...argusMonth));
        return;
      }
      if (this.month <= 0) {
        Util.showErrorMsg(this, Util.L("Error.Invalid0", ...argusMonth));
        return;
      }
      var argusYear = [Util.L("ManufactureYear")];
      if (Util.isNull(this.year) || Util.isEmpty(this.year.toString())) {
        Util.showErrorMsg(this, Util.L("Error.RequiredField0", ...argusYear));
        return;
      }
      if (this.year <= 0) {
        Util.showErrorMsg(this, Util.L("Error.Invalid0", ...argusYear));
        return;
      }
    }
    var items = this.purchaseOrderLines;
    var existedItems = items.filter((item) => item.sku === this.sku);
    if (existedItems.length > 0) {
      Util.showErrorMsg(this, "Error.SkuExisted");
      return;
    } else {
      this.spinShow = true;
      try {
        var product = null;
        if (!this.isReturnSO()) {
          product = await this.$store.dispatch({
            type: "product/checkClientProductBySku",
            data: {
              sku: this.sku,
              clientCode: this.purchaseOrder.clientCode,
            },
          });
        } else {
          product = await this.$store.dispatch({
            type: "purchaseOrder/checkPoProductBySku",
            data: {
              sku: this.sku,
              clientCode: this.purchaseOrder.clientCode,
              soId: this.purchaseOrder.returnSoId,
              assetTypeCode: this.purchaseOrder.assetTypeCode,
              conditionTypeCode: this.purchaseOrder.conditionTypeCode,
              qty: this.qty,
              poId: this.purchaseOrder.id,
              productType: this.purchaseOrder.productType,
            },
          });
        }

        if (!Util.isNull(product)) {
          var newLine = new CreatePurchaseOrderLineDto();
          newLine = {
            orderNo: 0,
            sku: product.sku,
            productName: product.name,
            productId: product.id,
            orderQty: this.qty,
            isPrep: false,
            packedQty: product.packedQty,
            id: 0,
            batchCode: "",
            manufactureMonth: null,
            month: +this.month,
            year: +this.year,
            price: 0,
            tax: 0,
            note: "",
          };
          this.purchaseOrderLines.push(newLine);
          this.pagePurchaseOrderLinesChange();
          this.sku = "";
          this.qty = 1;
        }
        this.spinShow = false;
      } catch (error) {
        this.spinShow = false;
      }
    }
  }

  onchangeQtyProduct(row: any, index: number) {
    var newValue = row.orderQty;
    if (Util.isNull(newValue) || newValue <= 0) {
      newValue = 1;
    }
    if (this.isReturnSO() && row.packedQty < newValue) {
      newValue = row.packedQty;
    }
    this.setObjectOrderQty(row, index, newValue);
    return newValue;
  }
  onchangePrice(row: any, index: number) {
    var newValue = row.price;
    if (Util.isNull(newValue) || newValue < 0) {
      newValue = 0;
    }
    this.setObjectPrice(row, index, newValue);
    return newValue;
  }
  onchangeTax(row: any, index: number) {
    var newValue = row.tax;
    if (Util.isNull(newValue) || newValue < 0) {
      newValue = 0;
    } else {
      newValue = _.min([newValue, 100]);
    }
    this.setObjectTax(row, index, newValue);
    return newValue;
  }
  onchangeNote(row: any, index: number) {
    var newValue = row.note;
    this.setObjectNote(row, index, newValue);
    return newValue;
  }
  getPoLineOrderQty(productId: number) {
    var line = this.purchaseOrderLines.find((i) => i.productId === productId);
    return line.orderQty;
  }
  setObjectNote(row: any, index: number, note: string) {
    this.purchaseOrderLinesPerPage[index].note = note;
    var line = this.purchaseOrderLines.find(
      (i) => i.productId === row.productId
    );
    line.note = note;
    row.note = note;
    this.getpage();
  }
  setObjectOrderQty(row: any, index: number, orderQty: number) {
    this.purchaseOrderLinesPerPage[index].orderQty = orderQty;
    var line = this.purchaseOrderLines.find(
      (i) => i.productId === row.productId
    );
    line.orderQty = orderQty;
    row.orderQty = orderQty;
    this.getpage();
  }
  setObjectPrice(row: any, index: number, price: number) {
    this.purchaseOrderLinesPerPage[index].price = price;
    var line = this.purchaseOrderLines.find(
      (i) => i.productId === row.productId
    );
    line.price = price;
    row.price = price;
    this.getpage();
  }
  setObjectTax(row: any, index: number, tax: number) {
    this.purchaseOrderLinesPerPage[index].tax = tax;
    var line = this.purchaseOrderLines.find(
      (i) => i.productId === row.productId
    );
    line.tax = tax;
    row.tax = tax;
    this.getpage();
  }
  async createPo() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreatePurchaseOrder"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          var lines = this.purchaseOrderLines.map((item) => {
            return {
              productId: item.productId,
              orderQty: item.orderQty,
              isPrep: item.isPrep,
              sku: item.sku,
              id: item.id,
              batchCode: item.batchCode,
              manufactureMonth: this.getManufactureMonth(item),
              price: _.isNil(item.price) ? 0 : item.price,
              tax: _.isNil(item.tax) ? 0 : item.tax,
              note: item.note,
            };
          });
          this.purchaseOrder.items = lines;
          await this.$store
            .dispatch({
              type: "purchaseOrder/create",
              data: this.purchaseOrder,
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.CreatePurchaseOrder");
              this.reset();
              this.$root.$router.push({ name: "purchaseorder" });
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  getManufactureMonth(item: any) {
    return this.isTp
      ? new Date(item.year, item.month - 1, 1, 0, 0, 0, 0)
      : null;
  }
  async updatePo() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.UpdatePurchaseOrder"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          var lines = this.purchaseOrderLines.map((item) => {
            return {
              productId: item.productId,
              orderQty: item.orderQty,
              isPrep: item.isPrep,
              sku: item.sku,
              id: item.id,
              batchCode: item.batchCode,
              manufactureMonth: this.getManufactureMonth(item),
              price: _.isNil(item.price) ? 0 : item.price,
              tax: _.isNil(item.tax) ? 0 : item.tax,
              note: item.note,
            };
          });
          this.purchaseOrder.items = lines;
          await this.$store
            .dispatch({
              type: "purchaseOrder/update",
              data: this.purchaseOrder,
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.UpdatePurchaseOrder");
              this.resetUpdate();
              this.getPoInfo();
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  async save() {
    (this.$refs.purchaseOrderForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.isUpdate()) {
          await this.updatePo();
        } else {
          await this.createPo();
        }
      }
    });
  }
  onGoBack() {
    this.$root.$router.push({ name: "purchaseorder" });
  }

  remove(index: number) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L(`Confirm.RemovePurchaseOrderProduct`),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        var item = this.purchaseOrderLinesPerPage[index];
        var items = this.purchaseOrderLines.filter(
          (i) => i.productId != item.productId
        );
        this.purchaseOrderLines = items;
        this.pagePurchaseOrderLinesChange();
      },
    });
  }

  async reset() {
    this.returnSalsOrders = new Array<SalesOrderForSelect>();
    this.suppliers = new Array<SupplierForSelect>();
    this.assetTypes = [];
    this.conditionTypes = [];
    await this.resetUpdate();
  }
  async resetUpdate() {
    this.sku = "";
    this.qty = 1;
    this.purchaseOrder = new CreatePurchaseOrderDto();
    this.products = new Array<ProductForSelect>();
    await this.resetList();
    this.objectLoading = false;
  }
  async resetChangeClientCode() {
    this.sku = "";
    this.qty = 1;
    this.returnSalsOrders = new Array<SalesOrderForSelect>();
    this.products = new Array<ProductForSelect>();
    this.suppliers = new Array<SupplierForSelect>();
    this.assetTypes = [];
    await this.resetList();
  }
  async resetList() {
    this.filterTotalCount = 0;
    this.pagerequest = new PagePurchaseOrderLineRequest();
    this.purchaseOrderLines = new Array<CreatePurchaseOrderLineDto>();
    this.purchaseOrderLinesPerPage = new Array<CreatePurchaseOrderLineDto>();
    await this.getpage();
  }

  // sale order line
  get list() {
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var re = this.purchaseOrderLinesPerPage.map((item, index) => {
      item.orderNo = startIndex + index + 1;
      return item;
    });
    return re;
  }

  get loading() {
    return this.$store.state.purchaseOrder.loading;
  }

  pageChange(page: number) {
    this.$store.commit("purchaseOrder/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("purchaseOrder/setPageSize", pagesize);
    this.getpage();
  }

  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    this.pagePurchaseOrderLinesChange();
  }

  pagePurchaseOrderLinesChange() {
    var items = this.purchaseOrderLines;
    if (
      !Util.isNull(this.pagerequest.sku) &&
      !Util.isEmpty(this.pagerequest.sku)
    ) {
      items = items.filter(
        (item) => item.sku.indexOf(this.pagerequest.sku) >= 0
      );
    }
    this.filterTotalCount = items.length;
    this.purchaseOrderLinesPerPage = Util.pagingItems(
      items,
      this.pageSize,
      this.currentPage
    );
  }

  get pageSize() {
    return this.$store.state.purchaseOrder.pageSize;
  }

  get totalCount() {
    return this.filterTotalCount;
  }

  get currentPage() {
    return this.$store.state.purchaseOrder.currentPage;
  }
  async created() {
    this.spinShow = true;
    try {
      this.code = this.$root.$router.currentRoute.params.code;
      this.clientCode = this.$root.$router.currentRoute.params.clientCode;
      this.purchaseOrder.shippingDate = new Date();
      this.purchaseOrder.returnSoId = 0;
      this.purchaseOrder.type = AppConsts.poTypes.standard;
      await this.getTypes();
      await this.getProductTypes();
      await this.getBuyFroms();
      this.getMonthList();
      this.getYearList();
      await this.getWarehouses();
      await this.getClients();
      await this.getConditionTypes();
      await this.getPoInfo();
      if (this.isUpdate()) {
        await this.loadClientData();
      } else {
        await this.changeClientCode();
      }
      if (
        _.isNil(this.purchaseOrder.productType) ||
        _.isEmpty(this.purchaseOrder.productType)
      ) {
        this.purchaseOrder.productType =
          _.isNil(this.productTypes) || this.productTypes.length === 0
            ? ""
            : this.productTypes[0].code;
      }
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  updated() {
    if (!this.isUpdate()) {
      if (this.isTenant()) {
        this.purchaseOrder.warehouseCode = this.$store.state.session.tenant.tenancyName;
        this.purchaseOrder.type = AppConsts.poTypes.returnSalesOrderAfterPack;
      }
    }
    this.getPoTypeName();
  }

  async getPoInfo() {
    if (!Util.isEmpty(this.code) && !Util.isEmpty(this.clientCode)) {
      this.$store
        .dispatch({
          type: "purchaseOrder/getPoInfoForUpdateByCode",
          data: { code: this.code, clientCode: this.clientCode },
        })
        .then((res) => {
          this.id = res.id;
          this.purchaseOrder = res;
          let shippingDate = new Date(
            Util.toReportDateString(this.purchaseOrder.shippingDate)
          );
          let invoiceDate = new Date(
            Util.toReportDateString(this.purchaseOrder.invoiceDate)
          );
          this.purchaseOrder.invoiceDate = invoiceDate;
          this.purchaseOrder.shippingDate = shippingDate;
          this.purchaseOrderLines = res.items;
          this.getpage();
          this.changeSupplier();
          this.changeProductType();
        });
    }
  }
  get columns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 70,
      },
      ...this.batchCodeColumn(),
      {
        title: Util.L("SKU"),
        key: "sku",
        width: 150,
      },
      {
        title: Util.L("ProductName"),
        key: "productName",
        width: 200,
      },
      {
        title: Util.L("Qty"),
        width: 150,
        slot: "orderQty",
      },

      ...this.tpColumns(),
      {
        title: Util.L("Price"),
        width: 150,
        slot: "price",
      },
      {
        title: Util.L("Tax"),
        width: 150,
        slot: "tax",
      },
      {
        title: Util.L("TotalAmount"),
        key: "amount",
        width: 150,
        render: (h: any, params: any) => {
          return h(
            "span",
            Util.toViewNumberString(params.row.price * params.row.orderQty)
          );
        },
      },
      {
        title: Util.L("Note"),
        width: 150,
        slot: "note",
      },
      {
        title: Util.L("Action"),
        width: 100,
        fixed: "right",
        slot: "action",
        align: "center",
      },
    ];
  }
  tpColumns() {
    return this.isTp
      ? [
          {
            title: Util.L("ManufactureMonth"),
            width: 150,
            slot: "manufactureMonth",
          },
          {
            title: Util.L("ManufactureYear"),
            width: 150,
            slot: "manufactureYear",
          },
        ]
      : [];
  }
  batchCodeColumn() {
    if (this.isTp && this.isUpdate()) {
      return [
        {
          title: Util.L("BatchCode"),
          width: 150,
          key: "batchCode",
        },
      ];
    }
    return [];
  }
  validateReturnSoId = (rule: any, value: any, callback: any) => {
    if (this.isReturnSO() && !this.isUpdate() && value <= 0) {
      callback(new Error(this.L("Error.RequiredField0")));
    } else {
      callback();
    }
  };
  validateShipSoId = (rule: any, value: any, callback: any) => {
    if (this.isReturnSO() && !this.isUpdate() && value <= 0) {
      callback(new Error(this.L("Error.RequiredField0")));
    } else {
      callback();
    }
  };
  validateUnicodeContainerNumber(rule, value, callback) {
    if (!value) {
      callback(
        new Error(
          this.L("Error.RequiredField0", undefined, this.L("ContainerNumber"))
        )
      );
    } else {
      if (Util.hasUnicode(value)) {
        callback(new Error(this.L("Error.InvalidContainerNumber")));
      } else {
        callback();
      }
    }
  }
  validateSpecialCharContainerNumber(rule, value, callback) {
    if (!value) {
      callback(
        new Error(
          this.L("Error.RequiredField0", undefined, this.L("ContainerNumber"))
        )
      );
    } else {
      var special = new RegExp(AppConsts.specialCharRegexPattern).test(value);
      if (special) {
        callback(new Error(this.L("Error.InvalidContainerNumber")));
      } else {
        callback();
      }
    }
  }
  purchaseOrderRule = {
    clientCode: [
      {
        required: this.isClient() || this.isUpdate() ? false : true,
        message: this.L("Error.RequiredField0", undefined, this.L("Client")),
        trigger: "blur",
      },
    ],
    warehouseCode: [
      {
        required: this.isTenant() ? false : true,
        message: this.L("Error.RequiredField0", undefined, this.L("Warehouse")),
        trigger: "blur",
      },
    ],
    productType: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ProductType")
        ),
        trigger: "blur",
      },
    ],
    buyFrom: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("BuyFrom")
        ),
        trigger: "blur",
      },
    ],
    returnSoId: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("SalesOrder")
        ),
        type: "number",
        min: 0,
        trigger: "blur",
      },
      { validator: this.validateReturnSoId, trigger: "blur" },
    ],
    externalSoId: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("SalesOrder")
        ),
        type: "number",
        min: 0,
        trigger: "blur",
      },
      { validator: this.validateShipSoId, trigger: "blur" },
    ],
    assetTypeCode: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("AssetType")),
        trigger: "blur",
      },
    ],
    conditionTypeCode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ConditionType")
        ),
        trigger: "blur",
      },
    ],
    containerNumber: [
      {
        required: this.isAccessories ? false : true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ContainerNumber")
        ),
        trigger: "blur",
      },
      { validator: this.validateUnicodeContainerNumber, trigger: "blur" },
      { validator: this.validateSpecialCharContainerNumber, trigger: "blur" },
    ],
    invoiceNumber: [
      {
        required: this.isAccessories ? false : true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("InvoiceNumber")
        ),
        trigger: "blur",
      },
    ],
    invoiceDate: [
      {
        required: this.isAccessories ? false : true,
        type: "date",
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("InvoiceDate")
        ),
        trigger: "blur",
      },
    ],
  };
}
